import React, { useState } from "react";
import { Box, Popover, TextField } from "@mui/material";
import { SketchPicker } from "react-color";

const WSColorPicker = ({ name, label, control, setValue, value }: any) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleOpen = (event: any) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleChange = (color: any) => {
    setValue(name, color.hex);
  };

  return (
    <>
      <TextField
        label={label}
        value={value || ""}
        onClick={handleOpen}
        fullWidth
        InputProps={{
          startAdornment: (
            <Box
              sx={{
                width: 20,
                height: 20,
                backgroundColor: value || "#fff",
                border: "1px solid #ccc",
                mr: 1,
              }}
            />
          ),
        }}
      />

      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
      >
        <SketchPicker color={value} onChange={handleChange} />
      </Popover>
    </>
  );
};

export default WSColorPicker;